/**
 * 인증된 API fetch 래퍼.
 * Supabase 세션 토큰을 자동 첨부하여 백엔드 JWT 검증 지원.
 */
import { supabase } from '@/lib/supabase'

export async function apiFetch(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  const { data: { session } } = await supabase.auth.getSession()
  const token = session?.access_token

  const headers = new Headers(options.headers)
  headers.set('Content-Type', 'application/json')

  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }
  if (session?.user?.id) {
    headers.set('X-Store-Id', session.user.id)
  }

  return fetch(path, { ...options, headers })
}
